@if (this.authServ.isUser.value && !this.authServ.isScreen.value) {
  <div
    class="topnav"
    >
  </div>
}

<div class="topnav-ruler"></div>
<!--
  v2.14.2: rimosso `<app-gestione-account-dettagli>` — era dead code
  (component rimosso in v2.3.0). Il tag zombie non renderizzava
  nulla da anni. Il flow "apri dettaglio account" ora passa dalla
  sidebar → /accounts?openAccountId=<id>.
-->
